export default __webpack_public_path__ + "static/media/element_90.fd81c76a.jpg";